import { isMetasearchTrafficSource } from 'lib/metasearch/metasearchSource'
import { isGHARedirection } from 'lib/optimizely/optimizelyUtils'

interface IsAccommodationV2BookingParams {
  property: Pick<App.Property.Property, 'accommV2Bookable'>
  isLoggedIn: boolean
  isAccommodationV2BookingsEnabled: boolean
  /** The page's rate source, from `getSource`. */
  source: string
  /** The page's `utm_content` query param. */
  utmContent: string | undefined
}

/**
 * Single gate for the accommodationV2 SPP checkout path.
 *
 * All of the following must be true:
 * - the `spp_accommodation_v2_bookings` feature flag is enabled
 * - property.accommV2Bookable (svc-accommodation content)
 * - customer is logged in (enquiry-session create requires auth)
 * - customer does not appear to have come from GHA/metasearch (a metasearch `source`, or a GHA
 *   `utm_content`): the enquiry session is created without the source or GHA price-match context
 *   those rates were priced with
 *
 * When false, callers must fall through to the legacy hotel / bedbankHotel path.
 */
export function isAccommodationV2Booking({
  property,
  isLoggedIn,
  isAccommodationV2BookingsEnabled,
  source,
  utmContent,
}: IsAccommodationV2BookingParams): boolean {
  const isMetasearchTraffic = isMetasearchTrafficSource(source) || isGHARedirection(utmContent)
  return isAccommodationV2BookingsEnabled && !!property.accommV2Bookable && isLoggedIn && !isMetasearchTraffic
}
